export const HomeSmIcon: React.FC<any> = ({ className }) => {
   return (
      <div
         className={className}
         dangerouslySetInnerHTML={{
            __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <g clip-path="url(#clip0_0_370)">
            <path d="M16.2279 4.71876V2.08093C16.2279 1.68993 15.9112 1.37259 15.5195 1.37259C15.1278 1.37259 14.8112 1.68993 14.8112 2.08093V3.75684L11.1257 1.26988C9.92228 0.458134 8.36678 0.458134 7.16332 1.26988L2.20499 4.61605C1.2282 5.27551 0.644531 6.37272 0.644531 7.55209V14.1226C0.644531 16.0755 2.23332 17.6643 4.1862 17.6643H6.3112C6.70291 17.6643 7.01953 17.3469 7.01953 16.9559V11.2893C7.01953 10.899 7.33686 10.5809 7.72786 10.5809H10.5612C10.9522 10.5809 11.2695 10.899 11.2695 11.2893V16.9559C11.2695 17.3469 11.5862 17.6643 11.9779 17.6643H14.1029C16.0557 17.6643 17.6445 16.0755 17.6445 14.1226V7.55209C17.6445 6.43222 17.1175 5.38601 16.2279 4.71876ZM16.2279 14.1226C16.2279 15.2942 15.2744 16.2476 14.1029 16.2476H12.6862V11.2893C12.6862 10.1177 11.7328 9.16426 10.5612 9.16426H7.72786C6.55628 9.16426 5.60286 10.1177 5.60286 11.2893V16.2476H4.1862C3.01461 16.2476 2.0612 15.2942 2.0612 14.1226V7.55209C2.0612 6.84447 2.41111 6.18572 2.99761 5.79047L7.95595 2.4443C8.67845 1.95697 9.61061 1.95697 10.3324 2.4443L15.2907 5.79047C15.8772 6.18572 16.2272 6.84447 16.2272 7.55209L16.2279 14.1226Z" fill="#7E7E7E"/>
        </g>
        <defs>
            <clipPath id="clip0_0_370">
            <rect width="17" height="17" fill="white" transform="translate(0.644531 0.664062)"/>
            </clipPath>
        </defs>
        </svg>
    `,
         }}
      />
   )
}
